import { Seo } from "../components/Seo";
import { site } from "../config/site";

export function PrivacyPage() {
  const policy = site.policies.privacy.trim();

  return (
    <main id="main" className="page">
      <Seo
        title="Privacy"
        description="Privacy information for Beautiful Jewellery."
        path="/privacy"
      />
      <p className="kicker">Privacy</p>
      <h1>Privacy</h1>
      {policy ? (
        <div className="info-card padded-card policy-copy section">{policy}</div>
      ) : (
        <p className="lede">We are preparing this page.</p>
      )}
    </main>
  );
}
